import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home"; // Keeping Home static for the fastest main page load

// 💥 FIX: Moved the hook import to the top with all other imports
import usePreventInspection from "./hooks/usePreventInspection";

// 1. Convert all page imports to use React.lazy()

// Core Components (usually kept in the main bundle, but can be lazy loaded too)
// const Home = lazy(() => import("./pages/Home")); // You can choose to keep Home non-lazy for fastest initial load, or lazy load it.

// Static Pages (Ideal candidates for lazy loading)
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

// Dynamic Pages (Ideal candidates for lazy loading)
const TopicNotes = lazy(() => import("./pages/TopicNotes"));
const NoteDetail = lazy(() => import("./pages/NoteDetail"));

function App() {
  //Prevent from the inspect
  usePreventInspection();
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />

        {/* Main Content Area: Responsive Padding */}
        <main className="flex-grow">
          {/* 2. Wrap the Routes with the Suspense component */}
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* 1. Root */}
              <Route path="/" element={<Home />} />

              {/* 2. Static Pages (Now lazy-loaded) */}
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />

              {/* 3. NESTED ROUTES FOR TOPICS AND NOTES (Now lazy-loaded) */}
              <Route path="/:topic" element={<TopicNotes />}>
                <Route path=":noteId" element={<NoteDetail />} />
              </Route>

              {/* 4. Catch-all route for 404 */}
              <Route
                path="*"
                element={
                  <div className="text-center py-20 text-xl text-gray-700">
                    <h1 className="text-4xl font-bold mb-4">
                      404 Page Not Found
                    </h1>
                    <p>The page you requested does not exist.</p>
                  </div>
                }
              />
            </Routes>
          </Suspense>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

// Simple fallback component to show while the page chunks load
const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-full p-20 text-2xl font-semibold text-indigo-600">
     Loading Page...
  </div>
);

export default App;
